/**
 * Middleware system for BaseModal
 */

/**
 * Run middleware chain
 * @param {Object} modal - Modal instance
 * @param {Array} middlewares - Array of middleware functions
 * @param {Object} context - Context object passed to middleware
 * @returns {Promise<boolean>} True if all middleware passed, false if interrupted
 */
export async function runMiddleware(modal, middlewares, context) {
    if (!middlewares || middlewares.length === 0) {
        return true;
    }

    let index     = 0;
    let completed = false;

    const next = async () => {
        if (completed) {
            return;
        }

        const middleware = middlewares[index++];

        if (typeof middleware !== 'function') {
            if (modal.config.debugMode) {
                console.warn('BaseModal: Middleware must be a function', middleware);
            }
            return next();
        }

        try {
            await middleware(context, next);
        } catch (error) {
            if (modal.config.debugMode) {
                console.error('BaseModal: Middleware error', error);
            }
            completed = true;
            return false;
        }
    };

    await next();

    // If completed is false, and we've gone through all middleware, it's successful
    return !completed || index >= middlewares.length;
}
